<template>
    <div class="tickets">
        <div class="ticket-container">
            <div class="ticket" id="ticket">
                <div class="ticket-content__title--box">
                    <picture
                        class="ticket-content__title--icon d-inline-block"
                    >
                        <source
                            :srcset="
                                require('@/assets/images/channel-logo/' +
                                    getCityLogo() +
                                    '.webp')
                            "
                            type="image/webp"
                        />
                        <img
                            :src="
                                require('@/assets/images/channel-logo/' +
                                    getCityLogo() +
                                    '.png')
                            "
                            :alt="getCityLogo()"
                        />
                    </picture>
                </div>
                <div class="ticket__dot ticket__dot--big"></div>
                <div class="ticket__dot ticket__dot--big"></div>
                <div class="ticket-content">
                    <div v-if="isShownHeader" class="ticket-content__title">
                        <div class="ticket-content__title--header">
                            <div class="ticket-content__title--header-main">
                                {{ cityName }}
                            </div>
                            <div class="ticket-content__title--header-sub">
                                {{ betData.currentGame.name }}
                            </div>
                        </div>
                    </div>
                     <div v-if="isShownHeader" class="ticket-content__date">
                        {{ betData.date }}
                    </div>

                    <div class="ticket-content__input">
                        <div class="ticket-content__input--bet">
                            <div class="ticket-content__input--bet--title">
                                Tiền cược 1 con
                            </div>
                            <InputCurrency
                                v-model="betMoney"
                                :min="0"
                                v-on:change-currency="isChangeAmount = false"
                                v-on:blur-currency="checkNumberOfNumber(true)"
                            />
                            <div
                                v-if="error.amount_one"
                                class="ticket-content__input--bet--error"
                            >
                                Bạn chưa nhập số tiền
                            </div>
                            <div
                                v-else-if="error.min_amount"
                                class="ticket-content__input--bet--error"
                            >
                                Tiền cược 1 con ít nhất là
                                {{
                                    (betData.currentGame.min_amount /
                                        clientBalanceUnit)
                                        | currency_not_symbol
                                }}
                                {{ clientCurrencyCode }}
                            </div>
                            <div class="ticket-content__input--bet--title mt-3">
                                Tổng tiền cược
                            </div>
                            <InputCurrency
                                v-model="amount"
                                :min="
                                    betData.currentGame.min_amount /
                                        clientBalanceUnit
                                "
                                v-on:change-currency="isChangeAmount = true"
                                v-on:blur-currency="checkNumberOfNumber(false)"
                            />
                            <div
                                v-if="error.bet_one"
                                class="ticket-content__input--bet--error"
                            >
                                Bạn chưa nhập số tiền
                            </div>
                            <div
                                v-else-if="error.min_bet"
                                class="ticket-content__input--bet--error"
                            >
                                Tiền cược ít nhất là
                                {{ amountMin | currency_not_symbol }}
                                {{ clientCurrencyCode }}
                            </div>
                        </div>
                        <div class="ticket__splitter mt-4">
                            <div class="ticket__dot ticket__dot--small"></div>
                            <div class="ticket__dot ticket__dot--small"></div>
                        </div>
                        <div class="ticket-content__input--number">
                            <div class="ticket-content__input--number-title">
                                Số đã chọn
                            </div>
                            <div
                                v-if="error.numbers"
                                class="ticket-content__input--bet--error mb-2"
                            >
                                Bạn chưa chọn số đánh
                            </div>
                            <div
                                class="ticket-content__input--number-numbers mt-1"
                            >
                                <CircleNumber
                                    v-for="number in paddingNumber(
                                        betData.numbers,
                                    )"
                                    :numberInput="number"
                                    :key="number"
                                />
                            </div>
                        </div>
                    </div>

                    <div
                        v-if="error.max_amount"
                        class="ticket-content__input--bet--error"
                    >
                        Tổng tiền cược nhiều nhất là
                        {{
                            (betData.currentGame.max_amount /
                                clientBalanceUnit)
                                | currency_not_symbol
                        }}
                        {{ clientCurrencyCode }}
                    </div>

                    <div class="ticket-content__win-money">
                        <div class="ticket-content__win-money--text">
                            Số tiền thắng 1 con
                        </div>
                        <div
                            class="ticket-content__win-money--number"
                        >
                            {{ winMoney | currency_not_symbol }}
                            {{ clientCurrencyCode }}
                        </div>
                    </div>
                    <div class="ticket-content__footer">
                        <Button
                            size="lg"
                            value="HỦY"
                            theme="light"
                            @click="cancelBet"
                            v-scroll-to="{
                                el: '#game',
                                offset: -10,
                                easing: 'linear',
                                duration: 100,
                            }"
                        />
                        <Button
                            size="lg"
                            variant="primary"
                            value="ĐẶT CƯỢC"
                            @click="onSubmitOrder"
                        />
                    </div>
                </div>
            </div>
        </div>

        <!--Additional ticket for mobile-->
        <div
            class="mobile-ticket"
            :class="
                isShowAdditionalTicket &&
                showAdditionalTicketByScroll &&
                betData.numbers.length !== 0
                    ? ''
                    : 'hide'
            "
        >
            <div class="mobile-ticket-content__text">
                Số đã chọn
            </div>
            <div class="mobile-ticket-content__select">
                <div class="mobile-ticket-content__select--number">
                    <CircleNumber
                        v-for="number in paddingNumber(betData.numbers)"
                        :numberInput="number"
                        :key="number"
                        variant="secondary"
                    />
                </div>
                <div class="mobile-ticket-content__select--button">
                    <Button
                        size="lg"
                        value="Chọn xong"
                        variant="primary"
                        v-scroll-to="{
                            el: '#ticket',
                            easing: 'linear',
                            duration: 100,
                        }"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import 'Ticket';
</style>
<script>
import orderService from '@common/services/order.service';
import Vue from 'vue';
import InputCurrency from '@/components/common/InputCurrency/InputCurrency';
import CircleNumber from '@/components/common/CircleNumber/CircleNumber';
import Button from '@/components/common/Button/Button';
import channelLogoJson from '@/assets/common/json/channel-logo.json';
import { mapActions, mapGetters } from 'vuex';
import VueScrollTo from 'vue-scrollto';
import { DEFAULT_ERROR_CODE, ERROR_CODE } from '@/utils/errorCode';
import betMixin from '@/mixins/bet.mixin';

Vue.use(VueScrollTo);

export default {
    components: {
        InputCurrency,
        CircleNumber,
        Button,
    },
    mixins: [betMixin],
    data() {
        return {
            cityName: '',
            betMoney: this.defaultAmountOne,
            clientCurrencyCode: process.env.VUE_APP_CLIENT_CURRENCY_CODE,
            clientBalanceUnit: process.env.VUE_APP_CLIENT_BALANCE_UNIT,
            amount: 0,
            winMoney: 0,
            selectedNum: [],
            error: {
                numbers: false,
                max_amount: false,
                min_amount: false,
                amount_one: false,
                bet_one: false,
                min_bet: false,
            },
            showAdditionalTicketByScroll: true,
            isChangeAmount: false,
            isLotruot: true,
        };
    },
    props: {
        isShownHeader: {
            type: Boolean,
            required: false,
            default: true,
        },
        defaultAmountOne: {
            type: Number,
            required: false,
            default: 1,
        },
        isShowAdditionalTicket: {
            type: Boolean,
            required: false,
            default: true,
        },
    },
    computed: {
        ...mapGetters({
            betData: 'betModule/betData',
            inPage: 'userModule/inPage',
            rates: 'betModule/rates',
        }),
        amountMin: function() {
            const numberOfNumbers = this.betData.currentGame.multi
                ? this.betData.numbers.length
                : 1;
            return numberOfNumbers * this.betData.currentGame.pay_number;
        },
    },
    methods: {
        ...mapActions({
            setBetDataByKey: 'betModule/setBetDataByKey',
        }),
        updateBetData: function() {
            this.cityName = this.betData.currentCity.name || 'Không xác định';
        },
        handleScroll: function() {
            const ticketOffset = 300;
            this.showAdditionalTicketByScroll =
                window.innerHeight + window.pageYOffset <
                document.body.offsetHeight - ticketOffset;
        },
        getCityLogo: function() {
            const cityId = this.betData.currentCity.id;
            return channelLogoJson[cityId]
                ? channelLogoJson[cityId].logo
                : 'not_found';
        },
        clearBetData() {
            this.betMoney = 1;
            this.amount = 1;
            this.setBetDataByKey({
                key: 'numbers',
                value: [],
            });
        },
        cancelBet: function() {
            this.clearBetData();
        },
        calculateBetMoney: function() {
            const numberOfNumbers = this.betData.currentGame.multi
                ? this.betData.numbers.length
                : 1;
            return (
                Number(this.betMoney) *
                numberOfNumbers *
                this.betData.currentGame.pay_number
            );
        },
        calculateAmount: function() {
            const numberOfNumbers = this.betData.currentGame.multi
                ? this.betData.numbers.length
                : 1;
            return numberOfNumbers
                ? Number(
                      Number(
                          this.amount /
                              (numberOfNumbers *
                                  this.betData.currentGame.pay_number),
                      ).toFixed(2),
                  )
                : 1;
        },
        calculateWinMoney: function() {
            return (
                this.betMoney *
                this.getCategoryRate(this.betData.currentGame.id)
            );
        },
        orderBet: function(orderData) {
            const token = this.$store.getters['userModule/token'];
            return orderService.orderBet(token, orderData);
        },
        onSubmitOrder: function() {
            if (!this.validateBetForm()) {
                return;
            }
            const numbers = this.paddingNumber(this.betData.numbers);
            const orderData = {
                amount: this.amount.toString(),
                amount_one: this.betMoney.toString(),
                city_id: this.betData.currentCity.id,
                category_id: this.betData.currentGame.id,
                numbers,
                partner: 's4ldv2_04',
                date: this.betData.date,
                region: this.betData.currentCity.region,
                confirm: false,
            };
            const lotruot = this.betData.currentGame.name;
            if(lotruot.includes('Lô trượt')) {
                this.onLotruotChecked();
            }
            else {
                this.showConfirmPopup(orderData);
            }
            
        },
        onOrderError({ response: { data: err } }) {
            const error = this.getError(err);
            const msg =
                this.inPage && error.inPageMsg
                    ? error.inPageMsg
                    : error.message;
            this.$swal
                .fire({
                    title: `<div class="popup__icon ${error.popupClass}"></div>`,
                    html: `<b>${msg}</b>`,
                    cancelButtonText: 'Hủy',
                    showCancelButton: !!error.redirectLink && !this.inPage,
                    reverseButtons: true,
                    customClass: {
                        popup: 'swal2-popup-warning-custom',
                    },
                    showCloseButton: true,
                })
                .then(res => {
                    if (error.redirectLink && res.isConfirmed) {
                        if (!this.inPage) {
                            window.location.href = error.redirectLink;
                        }
                        this.storeBetIfNotLogin(this.betData);
                    }
                });
        },
        showConfirmPopup(orderData) {
            this.$swal.queue([
                {
                    title: '<strong>ĐANG KIỂM TRA THÔNG TIN</strong>',
                    showLoaderOnConfirm: true,
                    html: 'Vui lòng chờ...',
                    showCancelButton: true,
                    cancelButtonText: 'Hủy',
                    reverseButtons: true,
                    customClass: {
                        popup:
                            'swal2-popup-warning-custom order-popup swal2-popup-html-custom',
                    },
                    allowOutsideClick: false,
                    didOpen: async popup => {
                        this.$swal.showLoading();
                        await new Promise(resolve => setTimeout(resolve, 750));
                        this.orderBet(orderData)
                            //show confirm popup
                            .then(({ data: { rows: orderDisplay } }) => {
                                popup.getElementsByClassName(
                                    'swal2-html-container',
                                )[0].innerHTML = this.prepareConfirmOrderContentHtml(
                                    orderDisplay,
                                );
                                popup.getElementsByClassName(
                                    'swal2-title',
                                )[0].innerHTML = this.prePareConfirmHeaderHtml();
                                popup
                                    .getElementsByClassName('swal2-cancel')[0]
                                    .addEventListener('click', () => {
                                        this.scrollBack();
                                        this.clearBetData();
                                    });
                                this.$swal.hideLoading();
                            })
                            .catch(this.onOrderError);
                    },
                    preConfirm: () => {
                        return this.confirmOrder(orderData);
                    },
                },
            ]);
        },
        confirmOrder(orderData) {
            orderData.confirm = true;
            return this.orderBet(orderData)
                .then(this.onOrderSuccess)
                .catch(this.onOrderError);
        },
        onLotruotChecked() {
            this.$swal
                .fire({
                    title:
                        '<div class="popup__icon popup__icon--limit-number"></div>',
                    text: 'Hệ thống đang có lỗi, vui lòng thử lại sau.',
                    customClass: {
                        popup: 'swal2-popup-warning-custom',
                    },
                    showCloseButton: true,
                })
                .then(() => {
                    this.scrollBack();
                    this.clearBetData();
                });
        },
        onOrderSuccess() {
            this.$swal
                .fire({
                    title:
                        '<div class="popup__icon popup__icon--bet-success"></div>',
                    text: 'Bạn đặt cược thành công.',
                    customClass: {
                        popup: 'swal2-popup-warning-custom',
                    },
                    showCloseButton: true,
                })
                .then(() => {
                    this.scrollBack();
                    this.clearBetData();
                });
        },
        scrollBack() {
            // Must wait for popup closes
            setTimeout(() => {
                VueScrollTo.scrollTo('#game', 100, {
                    easing: 'linear',
                    offset: -10,
                });
            }, 100);
        },
        paddingNumber(numbers) {
            const max = this.betData.currentGame.max;
            const betNumberLength = (max - 1).toString().length;
            const maxStrNumber = max / 10;
            return numbers.map(e => {
                if (e < maxStrNumber) {
                    return e.toString().padStart(betNumberLength, '0');
                } else {
                    return e;
                }
            });
        },
        prepareConfirmOrderContentHtml(confirmData) {
            let numbersTxt = '';
            const numbers = confirmData.numbers.split('-');
            for (const num of numbers) {
                const className =
                    num.length > 3 ? 'circle-number-3' : 'circle-number-2';
                const numHtml = `
                <button class="circle-number primary">
                    <span class="${className}">${num}</span>
                </button>`;
                numbersTxt += numHtml;
            }
            return `
            <div class="d-flex justify-content-between mt-3 mb-3">
                <div class="w-60 text-left pr-2">
                    <div class="order-popup__title font-weight-bold">Loại đề</div>
                    <div class="order-popup__content text-dark font-weight-bold">
                        ${this.cityName + ' - ' + this.betData.currentGame.name}
                    </div>
                </div>
                <div class="w-40 text-left">
                    <div class="order-popup__title font-weight-bold">Ngày</div>
                    <div class="order-popup__content text-dark font-weight-bold">
                        ${confirmData.date}
                    </div>
                </div>
            </div>
            <div class="d-flex justify-content-between mt-3 mb-3">
                <div class="w-60 text-left pr-2">
                    <div class="order-popup__title font-weight-bold">Số</div>
                    <div class="order-popup__numbers text-dark font-weight-bold">
                        ${numbersTxt}
                    </div>
                </div>
                <div class="w-40 text-left">
                    <div class="order-popup__title font-weight-bold">Tiền cược 1 con</div>
                    <div class="order-popup__content text-dark font-weight-bold">
                        ${this.$options.filters.currency_not_symbol(
                            this.betMoney,
                        ) +
                            ' ' +
                            this.clientCurrencyCode}
                    </div>
                </div>
            </div>
            <hr/>
            <div class="d-flex align-items-center mb-3">
                <div class="w-50 mr-custom text-right">
                    <span class="order-popup__title font-weight-bold">Tổng tiền cược</span>
                </div>
                <div class="w-50 ml-custom text-left">
                  <span class="order-popup__amount">
                      ${this.$options.filters.currency_not_symbol(
                          confirmData.amount / this.clientBalanceUnit,
                      ) +
                          ' ' +
                          this.clientCurrencyCode}
                  </span>
                </div>
            </div>
            <div class="d-flex align-items-center">
               <div class="w-50 mr-custom text-right">
                    <span class="order-popup__title font-weight-bold">Tiền thắng 1 con</span>
               </div>
               <div class="w-50 ml-custom text-left">
                  <span class="order-popup__win-money text-dark">
                      ${this.$options.filters.currency_not_symbol(
                          this.calculateWinMoney(),
                      ) +
                          ' ' +
                          this.clientCurrencyCode}
                  </span>
                </div>
            </div>
            `;
        },
        prePareConfirmHeaderHtml() {
            return '<strong>XÁC NHẬN ĐẶT CƯỢC</strong>';
        },
        validateBetForm() {
            this.error.amount_one = this.betMoney <= 0;
            this.error.numbers = this.betData.numbers.length === 0;
            const values = Object.values(this.error);
            // if all value is false => valid data => return true
            return values.every(v => v === false);
        },
        
        getError(err) {
            const { msg } = err;
            let error = ERROR_CODE.find(
                e => e.code.trim() === msg.toString().trim(),
            );
            if (!error) {
                error = ERROR_CODE.find(e => e.code === DEFAULT_ERROR_CODE);
            }
            const errorClone = { ...error };
            errorClone.message = error.message || msg;
            return errorClone;
        },
        getCategoryRate(catId) {
            if (Array.isArray(this.rates)) {
                const rateInfo = this.rates.find(
                    r => +r.category_id === +catId,
                );
                if (rateInfo) {
                    return rateInfo.rate;
                }
            }
            return 0;
        },
        checkNumberOfNumber(isBetMoney) {
            this.isChangeAmount = false;
            const message = isBetMoney
                ? 'Vui lòng chọn số trước khi nhập tiền cược.'
                : 'Vui lòng chọn số trước khi nhập tổng tiền cược.';
            if (this.betData.numbers.length < 1) {
                this.$swal
                    .fire({
                        title:
                            '<div class="popup__icon popup__icon--limit-number"></div>',
                        text: message,
                        customClass: {
                            popup: 'swal2-popup-warning-custom',
                        },
                        showCloseButton: true,
                    })
                    .then(() => {
                        this.scrollBack();
                        this.amount = 1;
                        this.betMoney = 1;
                    });
            }
        },
    },
    created() {
        window.addEventListener('scroll', this.handleScroll);
        this.amount = this.calculateBetMoney();
        this.winMoney = this.calculateWinMoney();
    },
    beforeMount() {
        this.updateBetData();
    },
    beforeUpdate() {
        this.updateBetData();
        if (this.isChangeAmount) {
            this.betMoney = this.calculateAmount();
        } else {
            this.amount = this.calculateBetMoney();
        }
        this.winMoney =
            this.selectedNum.length > 0 ? this.calculateWinMoney() : 0;
        this.selectedNum = this.betData.numbers;
    },
    watch: {
        selectedNum: function(v) {
            if (v.length > 0) {
                this.error.numbers = false;
                this.winMoney =
                    this.selectedNum.length > 0 ? this.calculateWinMoney() : 0;
            } else {
                this.isChangeAmount = false;
                this.betMoney = 1;
                this.amount = 1;
                this.winMoney = 0;
            }
            this.error.min_bet = this.amount < this.amountMin;
        },
        amount: function(v) {
            this.error.max_amount =
                this.betData.currentGame.max_amount <=
                v * this.clientBalanceUnit;
            this.error.min_bet = this.amount < this.amountMin;
            this.error.bet_one = this.isChangeAmount && this.amount <= 0;
        },
        betMoney: function(v) {
            this.betData.amountOne = this.betMoney >= 1 ? this.betMoney : 1;
            this.error.min_amount =
                this.betData.currentGame.min_amount / this.clientBalanceUnit >
                v;
            if (v > 0) {
                this.error.amount_one = false;
            }
        },
    },
};
</script>
